import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from '@/pages/home/components/Hero';
import TrendingSection from '@/pages/home/components/TrendingSection';
import EssenceSection from '@/pages/home/components/EssenceSection';
import LiveReplySection from '@/pages/home/components/LiveReplySection';
import DiscussionSection from '@/pages/home/components/DiscussionSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import DownloadSection from '@/pages/home/components/DownloadSection';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-100">
      <SiteHeader />
      <main className="w-full flex-1">
        <Hero />
        <TrendingSection />
        <EssenceSection />
        <LiveReplySection />
        <DiscussionSection />
        <TimelineSection />
        <DownloadSection />
      </main>
      <SiteFooter />
    </div>
  );
}